var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.627 2.31515C10.627 1.33416 9.83185 0.539062 8.85086 0.539062H2.70005C1.71906 0.539062 0.923828 1.33416 0.923828 2.31515V15.6379C0.923828 16.6189 1.71906 17.414 2.70005 17.414H8.85086C9.83185 17.414 10.627 16.6189 10.627 15.6379V2.31515ZM1.76758 3.61875H9.7832V13.4484H1.76758V3.61875ZM2.69148 1.38281H8.85943C9.37346 1.38281 9.7832 1.81128 9.7832 2.32544V2.775H1.76758V2.32544C1.76758 1.81128 2.17746 1.38281 2.69148 1.38281ZM8.85943 16.5703H2.69148C2.18471 16.574 1.77114 16.1658 1.76758 15.659V14.2922H9.7832V15.6482C9.78571 16.155 9.37702 16.5678 8.87024 16.5703H8.85943Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60046 15.0098H4.94922C4.71613 15.0098 4.52734 15.1986 4.52734 15.4316C4.52734 15.6647 4.71613 15.8535 4.94922 15.8535H6.60046C6.83342 15.8535 7.02234 15.6647 7.02234 15.4316C7.02234 15.1986 6.83342 15.0098 6.60046 15.0098Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.07ec3a2e33a14d0b18a3e482cda0b23b.svg";
export { ForwardRef as ReactComponent };